/* =========================================================
   WoodBuzz Modular Kitchens — Interactive Behaviors
   ========================================================= */

(function () {
  "use strict";

  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];

  const initKitchen = () => {
    // 1. Year Counter
    const yearEl = $("#year");
    if (yearEl) yearEl.textContent = new Date().getFullYear();

    // 2. Nav scrolled trigger
    const nav = $("#nav");
    const sticky = $("#stickyCta");
    const onScroll = () => {
      if (nav) nav.classList.toggle("scrolled", window.scrollY > 40);
      if (sticky) {
        const show = window.scrollY > window.innerHeight * 0.7;
        sticky.classList.toggle("translate-y-28", !show);
        sticky.classList.toggle("opacity-0", !show);
        sticky.classList.toggle("pointer-events-none", !show);
      }
    };
    window.addEventListener("scroll", onScroll);
    onScroll();

    // 3. Mobile Menu Handlers
    const mm = $("#mobileMenu");
    const menuBtn = $("#menuBtn");
    const menuClose = $("#menuClose");
    if (menuBtn && mm) menuBtn.addEventListener("click", () => mm.classList.remove("translate-x-full"));
    if (menuClose && mm) menuClose.addEventListener("click", () => mm.classList.add("translate-x-full"));
    if (mm) {
      mm.querySelectorAll("a").forEach(a => {
        a.addEventListener("click", () => mm.classList.add("translate-x-full"));
      });
    }

    // 4. Smooth Anchor Scroll
    let lenisInstance = null;
    if (window.Lenis) {
      lenisInstance = new Lenis({ duration: 1.1, smoothWheel: true });
      const raf = (t) => {
        lenisInstance.raf(t);
        requestAnimationFrame(raf);
      };
      requestAnimationFrame(raf);
    }

    document.querySelectorAll('a[href^="#"]').forEach(a => {
      a.addEventListener("click", (e) => {
        const id = a.getAttribute("href");
        if (id.length < 2) return;
        const target = $(id);
        if (!target) return;
        e.preventDefault();
        const y = target.getBoundingClientRect().top + window.scrollY - 90;
        if (lenisInstance) {
          lenisInstance.scrollTo(y, { duration: 1.2 });
        } else {
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      });
    });

    // 5. GSAP animations if present
    if (window.gsap) {
      gsap.registerPlugin(window.ScrollTrigger);
      if (lenisInstance && window.ScrollTrigger) {
        lenisInstance.on("scroll", ScrollTrigger.update);
      }

      const tl = gsap.timeline({ delay: 0.25 });
      tl.to(".line-inner", { y: "0%", duration: 1.1, stagger: 0.12, ease: "power4.out" })
        .to(".hero-fade", { opacity: 1, y: 0, duration: 0.8, stagger: 0.12, ease: "power2.out" }, "-=0.7");

      gsap.to(".hero-parallax", {
        yPercent: 10,
        ease: "none",
        scrollTrigger: { trigger: "#top", start: "top top", end: "bottom top", scrub: true }
      });
    } else {
      $$(".line-inner").forEach(n => n.style.transform = "none");
      $$(".hero-fade").forEach(n => n.style.opacity = "1");
    }

    // 6. Scroll reveals (IntersectionObserver)
    const revealEls = $$("[data-reveal]");
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver((entries, obs) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            const t = e.target;
            const sibs = Array.prototype.filter.call(t.parentElement ? t.parentElement.children : [t], c => c.hasAttribute("data-reveal"));
            const idx = Math.max(0, sibs.indexOf(t));
            t.style.transitionDelay = `${Math.min(idx * 70, 350)}ms`;
            t.classList.add("is-in");
            obs.unobserve(t);
          }
        });
      }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
      revealEls.forEach(n => io.observe(n));
    } else {
      revealEls.forEach(n => n.classList.add("is-in"));
    }

    // 7. Portfolio Categories Filters
    const filterBtns = $$("#filterBar .filter-btn");
    const galleryItems = $$("#galleryGrid [data-cat]");
    filterBtns.forEach(btn => {
      btn.addEventListener("click", () => {
        filterBtns.forEach(b => b.classList.remove("active"));
        btn.classList.add("active");
        const f = btn.getAttribute("data-filter");
        galleryItems.forEach(item => {
          const show = f === "All" || item.getAttribute("data-cat") === f;
          item.style.display = show ? "" : "none";
        });
      });
    });

    // 8. FAQ Accordions
    $$(".faq-item").forEach(item => {
      const btn = item.querySelector("button");
      const body = item.querySelector(".faq-body");
      const icon = item.querySelector("i");
      if (btn && body && icon) {
        btn.addEventListener("click", () => {
          const open = body.style.maxHeight && body.style.maxHeight !== "0px";
          $$(".faq-item .faq-body").forEach(b => b.style.maxHeight = "0px");
          $$(".faq-item button i").forEach(i => i.style.transform = "rotate(0deg)");
          if (!open) {
            body.style.maxHeight = `${body.scrollHeight}px`;
            icon.style.transform = "rotate(45deg)";
          }
        });
      }
    });

    // 9. Before/After slider
    const ba = $("#baSlider");
    if (ba) {
      const after = $("#baAfter");
      const handle = $("#baHandle");
      let dragging = false;
      const setPos = (clientX) => {
        const r = ba.getBoundingClientRect();
        let p = ((clientX - r.left) / r.width) * 100;
        p = Math.max(4, Math.min(96, p));
        if (after) after.style.clipPath = `inset(0 0 0 ${p}%)`;
        if (handle) handle.style.left = `${p}%`;
      };
      const move = (e) => {
        if (!dragging) return;
        setPos(e.touches ? e.touches[0].clientX : e.clientX);
      };
      ba.addEventListener("mousedown", (e) => {
        dragging = true;
        setPos(e.clientX);
      });
      ba.addEventListener("touchstart", (e) => {
        dragging = true;
        setPos(e.touches[0].clientX);
      }, { passive: true });
      window.addEventListener("mousemove", move);
      window.addEventListener("touchmove", move, { passive: true });
      window.addEventListener("mouseup", () => dragging = false);
      window.addEventListener("touchend", () => dragging = false);
    }

    // 10. Custom cursor tracker
    const dot = $("#cursorDot");
    const ring = $("#cursorRing");
    if (dot && ring && window.matchMedia("(hover:hover)").matches) {
      let rx = 0, ry = 0, dx = 0, dy = 0;
      let isHovered = false;
      window.addEventListener("mousemove", (e) => {
        dx = e.clientX;
        dy = e.clientY;
        dot.style.transform = `translate(${dx}px, ${dy}px) translate(-50%,-50%)`;
      });
      const loop = () => {
        rx += (dx - rx) * 0.18;
        ry += (dy - ry) * 0.18;
        const scale = isHovered ? " scale(1.35)" : "";
        ring.style.transform = `translate(${rx}px, ${ry}px) translate(-50%,-50%)${scale}`;
        requestAnimationFrame(loop);
      };
      loop();
      document.addEventListener("mouseover", (e) => {
        if (e.target.closest("[data-cursor], a, button, input, select")) {
          isHovered = true;
          ring.style.borderColor = "rgba(31,91,62,.7)";
        }
      });
      document.addEventListener("mouseout", (e) => {
        if (e.target.closest("[data-cursor], a, button, input, select")) {
          isHovered = false;
          ring.style.borderColor = "rgba(184,115,51,.6)";
        }
      });
    }

    // 11. Consultation Modal Handler
    const modal = $("#consultModal");
    const modalOverlay = $("#modalOverlay");
    const modalCard = $("#modalCard");
    const openModal = () => {
      if (!modal) return;
      if (mm) mm.classList.add("translate-x-full");
      modal.classList.remove("hidden");
      document.body.style.overflow = "hidden";
      if (lenisInstance) lenisInstance.stop();
      requestAnimationFrame(() => {
        if (modalOverlay) modalOverlay.style.opacity = "1";
        if (modalCard) {
          modalCard.style.opacity = "1";
          modalCard.style.transform = "scale(1)";
        }
      });
      const first = modal.querySelector("input[name='name']");
      if (first) setTimeout(() => first.focus(), 380);
    };

    const closeModal = () => {
      if (!modal) return;
      if (modalOverlay) modalOverlay.style.opacity = "0";
      if (modalCard) {
        modalCard.style.opacity = "0";
        modalCard.style.transform = "scale(0.95)";
      }
      document.body.style.overflow = "";
      if (lenisInstance) lenisInstance.start();
      setTimeout(() => modal.classList.add("hidden"), 340);
    };

    window.closeConsultModal = closeModal;

    document.querySelectorAll("[data-open-modal]").forEach(b => {
      b.addEventListener("click", (e) => {
        e.preventDefault();
        openModal();
      });
    });

    const mClose = $("#modalClose");
    if (mClose) mClose.addEventListener("click", closeModal);
    if (modalOverlay) modalOverlay.addEventListener("click", closeModal);
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && modal && !modal.classList.contains("hidden")) closeModal();
    });

    // 12. Lead Form Submit (AJAX)
    const form = $("#leadForm");
    const submitBtn = $("#leadSubmit");
    if (form) {
      form.addEventListener("submit", async (e) => {
        e.preventDefault();
        if (!submitBtn) return;

        const nameEl = $("#leadForm input[name='name']");
        const phoneEl = $("#leadForm input[name='phone']") || $("#leadForm input[name='mobile']");
        const name = nameEl ? nameEl.value.trim() : "";
        const mobile = phoneEl ? phoneEl.value.trim() : "";

        const cityEl = $("#leadForm select[name='city']");
        const budgetEl = $("#leadForm select[name='budget']");
        const city = cityEl ? cityEl.value : "";
        const budget = budgetEl ? budgetEl.value : "";

        if (!name || !mobile) {
          alert('Please enter your name and phone number.');
          return;
        }

        submitBtn.disabled = true;
        submitBtn.innerHTML = 'Sending… <i class="fa-solid fa-spinner fa-spin"></i>';

        const data = {
          name,
          mobile,
          city,
          budget,
          _subject: 'New Modular Kitchen Lead Inquiry'
        };

        try {
          const res = await fetch('https://formsubmit.co/ajax/Abhishek.sahu@ixdesigns.in', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(data),
          });
          const json = await res.json();
          if (json.success === "true" || json.success === true || res.ok) {
            form.innerHTML = `
              <div class="text-center py-10 px-5 text-walnut">
                <div class="w-16 h-16 rounded-full bg-forest/10 text-forest flex items-center justify-center text-3xl mx-auto mb-6">✓</div>
                <h3 class="font-display text-3xl mb-3 text-walnut-ink">Consultation Booked!</h3>
                <p class="text-walnut/70 text-sm max-w-sm mx-auto leading-relaxed mb-6">Thank you for requesting a kitchen consultation. A senior designer will contact you within 24 hours.</p>
                <button class="btn btn-primary px-6 py-3" onclick="closeConsultModal()">Close</button>
              </div>
            `;
          } else {
            throw new Error('Submission failed');
          }
        } catch (err) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = 'Book Free Consultation <i class="fa-solid fa-arrow-right"></i>';
          alert('Failed to send consultation request. Please try again.');
        }
      });
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initKitchen);
  } else {
    initKitchen();
  }
})();
